import { useCallback } from 'react';
import { useAxios } from '../../hooks/useAxios';
import { doGet, doPatch, doPost, doPut } from 'hooks/requests';

export const useCompanyService = () => {
    const { get } = useAxios();

    const getCurrencyList = useCallback(
        (companyId) => get(`/company/currency_list/${companyId}`),
        [get],
    );

    const getUserAssociatedCompany = useCallback(() => doGet('/company/user/'), []);

    const createCompany = (name, industry, entity, timezone, address) =>
        doPost('/company/', { name, industry, entity, timezone, address });

    const updateCompany = (id, data) => doPatch(`/company/${id}/update/`, { ...data });

    const createStripeSession = (companyId) =>
        get(`/company/stripe-portal-url/?company_id=${companyId}`);

    const getStripeTableSession = (companyId) =>
        doGet(`/company/stripe-customer-session/?company_id=${companyId}`);

    const getCompanyEmails = (companyId, amount, date) =>
        get(`/company/get-company-emails/?company_id=${companyId}&amount=${amount}&date=${date}`);

    const getCompanyEmailsWithInventory = ({ companyId, page, searchText, date, amount }) => {
        const params = new URLSearchParams({
            company_id: companyId.toString(),
            page: page.toString(),
        });

        if (date) params.append('date', date);
        if (amount) params.append('amount', amount);
        if (searchText) params.append('search', searchText);

        return doGet(`company/get-company-emails/inventory/?${params.toString()}`);
    };

    const getCompanyUsers = ({ companyId, page }) => {
        const params = new URLSearchParams({
            company_id: companyId.toString(),
            page: page.toString(),
        });

        return doGet(`company/get-users/?${params.toString()}`);
    };

    const createCompanyUser = (data) => doPost(`/company/add-user/`, data);

    const updateCompanyUser = (data) => doPut(`/company/update-user/`, data);

    const updateCompanyUserStatus = (data) => doPut(`/company/update-user/status/`, data);

    const getCompanyUsersDropdown = (companyId) => {
        const params = new URLSearchParams({
            company_id: companyId.toString(),
        });

        return doGet(`company/get-users-dropdown/?${params.toString()}`);
    };

    const updateBookKeepingMode = (data) => doPut(`/company/toggle/`, data);

    const getCompanyBilling = (data) => doGet(`/company/limit-usage/?company_id=${data}`);

    const getInventoryTags = (companyId) => {
        const params = new URLSearchParams({
            company_id: companyId.toString(),
        });
        return doGet(`/inventory/aggregated-inventory-tags/?${params.toString()}`);
    };

    const getCompanyIntegrations = (companyId) =>
        doGet(`/company/get-integrations/?company_id=${companyId}`);

    return {
        createCompany,
        updateCompany,
        getCompanyUsers,
        getCurrencyList,
        getCompanyEmails,
        getInventoryTags,
        getCompanyBilling,
        createCompanyUser,
        updateCompanyUser,
        createStripeSession,
        updateBookKeepingMode,
        getStripeTableSession,
        getCompanyIntegrations,
        getCompanyUsersDropdown,
        updateCompanyUserStatus,
        getUserAssociatedCompany,
        getCompanyEmailsWithInventory,
    };
};
